import {
  RepairBumperPaymentTypeEnum,
  RepairPaymentTypeEnum,
  RepairResourceTypeEnum,
} from '@vatos-pas/common';
import type { RepairFormulaFormValues } from '../containers';

type ValidationErrors = Record<string, string[] | undefined>;

export const validateRepairFormula = async (
  values: RepairFormulaFormValues,
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};

  if (!values.repairId) {
    errors.repairId = ['The Repair Type is required'];
  }
  if (!values.repairResourceType) {
    errors.repairResourceType = ['The Resource Type Id is required'];
  }
  if (!values.repairBumperPaymentType) {
    errors.repairBumperPaymentType = ['The Bumper Payment Type is required'];
  }
  if (!values.repairPaymentType) {
    errors.repairPaymentType = ['The Repair Payment Type is required'];
  }
  if (
    values.repairResourceType === RepairResourceTypeEnum.Bumper &&
    values.repairBumperPaymentType === RepairBumperPaymentTypeEnum.NA
  ) {
    errors.repairBumperPaymentType = [
      "If the Resource Type is Bumper, the Bumper Payment Type can't be NA",
    ];
  }
  const bumperOnlyPaymentTypes: RepairPaymentTypeEnum[] = [
    RepairPaymentTypeEnum.PerDay,
    RepairPaymentTypeEnum.ExtraHours,
  ];
  if (
    values.repairResourceType !== RepairResourceTypeEnum.Bumper &&
    bumperOnlyPaymentTypes.includes(values.repairPaymentType as RepairPaymentTypeEnum)
  ) {
    errors.repairPaymentType = [
      'Error! This Repair Payment Type is exclusive to Bumpers, please select a different Repair Payment Type to proceed.',
    ];
  }
  return errors;
};
